import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { paginatedResponse } from '#web-service-api/common';
export const GuestResponseSchema = z.object({
    email: z.string(),
    linksCount: z.number(),
    lastUsedAt: dateParser().nullable(),
});
export class GuestResponseDto extends createZodDto(GuestResponseSchema) {
}
const guestsListResponseSchema = paginatedResponse(GuestResponseSchema);
export class GuestsListResponseDto extends createZodDto(guestsListResponseSchema) {
}
